import React, { Fragment, useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux"; // Import useDispatch hook
import { Row, Container, Input, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import GreetingCard from "../../Components/Recruiter/Dashboard/GreetingCard";
import WidgetsWrapper from "../../Components/Recruiter/Dashboard/WidgetsWraper";
import TopActiveJobs from "../../Components/Recruiter/Dashboard/TopActiveJobs";
import Acquisitions from "../../Components/Recruiter/Dashboard/Acquisitions";
import JobDataTable from "../../Components/Recruiter/Dashboard/JobDataTable";
import NewApplicants from "../../Components/Recruiter/Dashboard/NewApplicants";
import { fetchDashboardDataRequest } from "../../redux/recruiter/dashboard/actions";
import { getTotalPointsRequest } from "../../redux/get_total_points/actions";
import "react-date-range/dist/styles.css"; // Main style file
import "react-date-range/dist/theme/default.css"; // Theme CSS file
import { DateRange } from "react-date-range";
const DashboardRecruiter = () => {
  const dispatch = useDispatch(); // Initialize useDispatch hook
  const [selectedDateRange, setSelectedDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [isDateRangePickerOpen, setIsDateRangePickerOpen] = useState(false);
  const dateRangePickerRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [reportType, setReportType] = useState('YOUR_REPORT'); // default value


  // Call dispatch inside any event handler or useEffect hook
  useEffect(() => {
    dispatch(fetchDashboardDataRequest({ reportType: reportType }));
  }, [reportType]); // Make sure to add dispatch to the dependency array if you are using it inside useEffect



  const toggle = () => setDropdownOpen(prevState => !prevState);
  const options = [
    { value: '', label: 'Company Level' },
    { value: 'YOUR_REPORT', label: 'Your Report' }
  ];
  const handleSelect = (value) => {
    setReportType(value);
    // Delay closing the dropdown to avoid event interference
    setTimeout(() => setDropdownOpen(false), 0);
  };



  const handleChange = (e) => {
    const selectedType = e.target.value;
    setReportType(selectedType);

  };

  const locale = {
    localize: {
      month: (monthIndex) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return months[monthIndex];
      },
      day: (dayIndex) => {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return days[dayIndex];
      },
    },
    formatLong: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  const handleToggleDateRangePicker = () => {
    setIsDateRangePickerOpen(!isDateRangePickerOpen);
  };

  const handleDateRangePickerClose = () => {
    setIsDateRangePickerOpen(false);
  };



  return (
    <Fragment>
      <Breadcrumbs title="Dashboard" mainTitle="Dashboard" />
      <Container fluid={true}>
        <Row className="widget-grid position-relative">
          {/* <Col
            xxl="12"
            lg="12"
            className="box-col-12 d-flex justify-content-end"
          >
            <Input
              className="mb-3 form-control custom-input-width"
              type="text"
              placeholder="Select date range"
              onFocus={handleToggleDateRangePicker}
              readOnly // Prevent typing in the input field
              style={{ width: "150px" }} // Adjust the width as needed
            />
            {isDateRangePickerOpen && (
              <div
                ref={dateRangePickerRef}
                className="position-absolute"
                style={{ zIndex: "9999", top: "38px", right: "0" }}
              >
                <DateRange
                  editableDateInputs={true}
                  onChange={(item) => {
                    if (item.selection) {
                      setSelectedDateRange([item.selection]);
                    }
                  }}
                  moveRangeOnFirstSelection={false}
                  ranges={selectedDateRange}
                  locale={{
                    ...locale, // Spread the locale object here
                    format: "MM/dd/yyyy",
                    separator: " - ",
                    applyLabel: "Apply",
                    cancelLabel: "Cancel",
                    weekStartsOn: 0,
                  }}
                  onClose={handleDateRangePickerClose}
                />
              </div>
            )}
          </Col> */}
          <Col xl="12" lg="12" md="12" sm="12" className="">
            <div className="d-flex flex-end justify-content-end mb-3 align-items-center">
              <Dropdown isOpen={dropdownOpen} toggle={toggle} autoClose="inside">
                <DropdownToggle caret>
                  {options.find(option => option.value === reportType)?.label || options[0].label}
                </DropdownToggle>
                <DropdownMenu>
                  {options.map((item, i) => (
                    <DropdownItem key={i} onClick={() => handleSelect(item.value)}>
                      {item.label}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
          </Col>
          <Col xxl="4" lg="12" md="12" sm="12" className="">
            <GreetingCard />
          </Col>
          <Col xxl="8" lg="12" md="12" sm="12" className="">
            <WidgetsWrapper reportType={reportType} />
          </Col>
          <Col xxl="8" xl="12" lg="12" md="12" sm="12" className="">
            <TopActiveJobs reportType={reportType} />
          </Col>
          <Col xxl="4" xl="12" lg="12" md="12" sm="12" className="">
            <NewApplicants />
          </Col>
          <Col xl="12" lg="12" md="12" sm="12" className="">
            <JobDataTable />
          </Col>
          {/* <TimelineCard />
          <PreAccountCard />
          <TotalUserAndFollower />
          <PaperNote /> */}
        </Row>
      </Container>
    </Fragment>
  );
};

export default DashboardRecruiter;
